import comp from "./SectionDetails";
export default comp;
